import React from "react"
import SbEditable from "storyblok-react"
import { useStaticQuery, graphql } from "gatsby"
import PostListCard from "../PostListCard"

import { StyledPostsList } from "./styles"
// import rewriteSlug from "../utils/rewriteSlug"

const AlbumsList = ({ blok }) => {
  let filteredPosts = []
  const isResolved = typeof blok.albums[0] !== "string"

  const data = useStaticQuery(graphql`
    {
      albums: allStoryblokEntry(filter: { field_component: { eq: "album" } }) {
        edges {
          node {
            id
            uuid
            name
            slug
            full_slug
            content
            created_at
          }
        }
      }
    }
  `)

  if (!isResolved) {
    // filteredPosts = data.posts.edges.filter(
    //   p => blok.posts.indexOf(p.node.uuid) > -1
    // )

    filteredPosts = data.albums.edges.map((p, i) => {
      const content = p.node.content
      const newContent =
        typeof content === "string" ? JSON.parse(content) : content
      p.node.content = newContent
      return p.node
    })
  }

  const arrayOfAlbums = isResolved ? blok.albums : filteredPosts

  return (
    <SbEditable content={blok} key={blok._uid}>
      <StyledPostsList>
        {arrayOfAlbums.map(post => {
          return <PostListCard post={post} key={post.id} />
        })}
      </StyledPostsList>
    </SbEditable>
  )
}

export default AlbumsList
